import {
  IMembershipSubscriptionStatus,
  IMembershipSubscriptionProvider,
  IUser
} from "@dietdoctor/elements";

type MaybeUser = {
  firstName?: IUser["firstName"];
  lastName?: IUser["lastName"];
  membershipSubscription?: {
    status?: IMembershipSubscriptionStatus;
    provider?: IMembershipSubscriptionProvider;
  };
};

type MaybePro = {
  group?: IUser["pro"]["group"];
};

const safeFirstName = (x: MaybeUser): string => (x.firstName ? x.firstName : "");
const safeLastName = (x: MaybeUser): string => (x.lastName ? x.lastName : "");
const safeMembershipStatus = (x: MaybeUser) =>
  (x.membershipSubscription ? x.membershipSubscription : { status: "" }) as {
    status: IMembershipSubscriptionStatus;
  };
const safeMembershipProvider = (x: MaybeUser) =>
  (x.membershipSubscription ? x.membershipSubscription : { provider: "" }) as {
    provider: IMembershipSubscriptionProvider;
  };
const safePro = (win: Window): MaybePro => (win.ckdc?.pro ? win.ckdc.pro : undefined);
const safeStatus = (x: MaybeUser["membershipSubscription"]) =>
  (x.status ? x.status : "") as IMembershipSubscriptionStatus;
const safeProvider = (x: MaybeUser["membershipSubscription"]) =>
  (x.provider ? x.provider : "") as IMembershipSubscriptionProvider;
const safeUser = (win: Window): MaybeUser => (win.ckdc?.user ? win.ckdc.user : null);

export const getUser = (win: Window): IUser => {
  const user = safeUser(win);

  if (!user) {
    return null;
  }

  const firstName = safeFirstName(user);
  const lastName = safeLastName(user);
  const status = safeStatus(safeMembershipStatus(user));
  const provider = safeProvider(safeMembershipProvider(user));
  const pro = safePro(window);

  return {
    firstName,
    lastName,
    membershipSubscription: {
      status,
      provider
    },
    pro
  } as IUser;
};
